import React, { createContext, useContext, useState } from 'react';

const SessionModalContext = createContext();

export const useSessionModal = () => useContext(SessionModalContext);

export const SessionModalProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('Your session has been terminated. Please log in again');

    const showModal = (msg) => {
        setMessage(msg || '');
        setOpen(true);
    };
    const hideModal = () => setOpen(false);

    return (
        <SessionModalContext.Provider value={{ open, showModal, hideModal, message }}>
            {children}
        </SessionModalContext.Provider>
    );
};


